import { defineMessages, IntlShape } from "react-intl";

import { EntityType, EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";

import TextGetters from "../types/TextGetters";

const pinsCountMessages = defineMessages<string>({
  [EntityType.COMPANY]: {
    id: "recordList.count.accounts",
    defaultMessage:
      "{count, plural, =0 {No companies} one {{count} Company} other {{count} Companies}}",
    description: "Companies count formatter in the sidebar in Map view",
  },
  [EntityType.DEAL]: {
    id: "recordList.count.deals",
    defaultMessage: "{count, plural, =0 {No deals} one {{count} Deal} other {{count} Deals}}",
    description: "Deals count formatter in the sidebar in Map view",
  },
  [EntityType.PERSON]: {
    id: "recordList.count.contacts",
    defaultMessage: "{count, plural, =0 {No people} one {{count} Person} other {{count} People}}",
    description: "People count formatter in the sidebar in Map view",
  },
  monoEntityCount: {
    id: "recordList.count.monoEntity",
    defaultMessage:
      "{entityType, select, accounts {{count, plural, =0 {No companies} one {{count} company} other {{count} companies}}} contacts {{count, plural, =0 {No people} one {{count} person} other {{count} people}}} deals {{count, plural, =0 {No deals} one {{count} deal} other {{count} deals}}} other {{count, plural, =0 {No records} one {{count} record} other {{count} records}}}}",
    description: "Total number of records in the Sidebar",
  },
  pins: {
    id: "recordList.count.pins",
    defaultMessage: "{count, plural, =0 {No pins} one {{count} Pin} other {{count} Pins}}",
    description: "Pins count formatter in the sidebar in Map view",
  },
  records: {
    id: "recordList.count.records",
    defaultMessage: "{count, plural, =0 {No records} one {{count} Record} other {{count} Records}}",
    description: "Records count formatter in the sidebar in Map view",
  },
});

export const pinsCountTextGetterFactory =
  (
    intl: IntlShape,
    visibleEntities: EntityTypesSupportedByMapsPage[]
  ): TextGetters["countTextGetter"] =>
  (count) =>
    intl.formatMessage(
      visibleEntities.length === 1 ? pinsCountMessages[visibleEntities[0]] : pinsCountMessages.pins,
      { count }
    );

export const recordsCountTextGetterFactory =
  (intl: IntlShape): TextGetters["countTextGetter"] =>
  (count) =>
    intl.formatMessage(pinsCountMessages.records, { count });

export const monoEntitiesCountTextGetterFactory =
  (intl: IntlShape, entityType?: EntityTypesSupportedByMapsPage): TextGetters["countTextGetter"] =>
  (count) =>
    intl.formatMessage(pinsCountMessages.monoEntityCount, {
      count,
      entityType,
    });
